export const DEFAULT_TARIFF_KEY = "PARTNER";

const normalizeCode = (value) =>
  String(value || "")
    .trim()
    .toUpperCase();

const toOptionalDate = (value) => {
  if (!value) {
    return null;
  }
  if (typeof value === "string") {
    return value;
  }
  if (value.format) {
    return value.format("YYYY-MM-DD");
  }
  return value;
};

export const toDiscountCodePayload = (values) => ({
  code: normalizeCode(values.code),
  tariffKey: normalizeCode(values.tariffKey) || DEFAULT_TARIFF_KEY,
  label: values.label || null,
  active: values.active !== false,
  startDate: toOptionalDate(values.startDate),
  endDate: toOptionalDate(values.endDate),
  process: { id: values.process && values.process.id },
});

export const toDiscountCodeFormValues = (data = {}) => ({
  code: data.code || "",
  tariffKey: data.tariffKey || DEFAULT_TARIFF_KEY,
  label: data.label || "",
  active: data.active !== false,
  startDate: data.startDate || "",
  endDate: data.endDate || "",
  process: {
    id: (data.process && data.process.id) || "",
    name: (data.process && data.process.name) || "",
  },
});
